module.exports = __webpack_public_path__ + "img/vertical_7_7_7016.f1b3a195.png";